import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

// 导入语言文件
import en from "./locales/en";
import zhCN from "./locales/zh-CN";

// 获取默认语言 - 默认为中文
const getDefaultLocale = () => {
  const savedLocale = localStorage.getItem("locale");
  if (savedLocale) return savedLocale;

  // 默认使用中文
  return "zh-CN";
};

const i18n = new VueI18n({
  locale: getDefaultLocale(),
  fallbackLocale: "en",
  messages: {
    en,
    "zh-CN": zhCN,
  },
  silentTranslationWarn: true,
});

export default i18n;
